import Tooltip from '@cartwhl/ui/atoms/Tooltip';

import { ExcludedBoneIcon } from '../../../presentations/icons';

interface ExcludedOverrideControlProps {
  excluded: boolean;
  onToggle: () => void;
}

const BUTTON_BASE_CLASS =
  'group focus-visible inline-flex h-5 w-full items-center justify-center rounded-md transition-colors duration-150';
const BUTTON_ACTIVE_CLASS =
  'bg-gray-15/25 text-red hover:bg-gray-15 dark:bg-gray-90/25 dark:text-red dark:hover:bg-gray-90';
const BUTTON_INACTIVE_CLASS =
  'bg-gray-15/15 text-tertiary hover:bg-gray-15 hover:text-secondary dark:bg-gray-90/15 dark:hover:bg-gray-90';

export default function ExcludedOverrideControl({
  excluded,
  onToggle,
}: ExcludedOverrideControlProps) {
  const tooltipText = excluded
    ? 'Include this bone in mapping'
    : 'Exclude this bone from mapping';

  const stopPropagation = (event: { stopPropagation: () => void }) => {
    event.stopPropagation();
  };

  return (
    <Tooltip text={tooltipText} side="top" inModal>
      <button
        type="button"
        className={`${BUTTON_BASE_CLASS} ${
          excluded ? BUTTON_ACTIVE_CLASS : BUTTON_INACTIVE_CLASS
        }`}
        onPointerDown={stopPropagation}
        onClick={(event) => {
          stopPropagation(event);
          onToggle();
        }}
        aria-label={tooltipText}
        aria-pressed={excluded}
      >
        <ExcludedBoneIcon
          className={`h-3.5 w-3.5 transition-opacity duration-150 ${
            excluded ? 'opacity-100' : 'opacity-70 group-hover:opacity-100'
          }`}
        />
      </button>
    </Tooltip>
  );
}
